export const sortImagesFromGatsby = imgArr => {
  return imgArr
    ? imgArr.sort((a, b) => {
        const wwa = a?.childImageSharp?.gatsbyImageData?.images?.fallback?.src;
        const wwb = b?.childImageSharp?.gatsbyImageData?.images?.fallback?.src;

        let aa = wwa?.split("__")[1]?.split(".")[0] * 1;
        let bb = wwb?.split("__")[1]?.split(".")[0] * 1;

        return aa - bb;
      })
    : imgArr;
};

export function fisherYatesShuffle(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

const domainBuildCodes = {
  /**
   * new 555travel domains
   */
  HOME555TRAVEL: "home555travel",
  TINSPIRE_000: "tinspire000",
  TINSPIRE_001: "tinspire001",
  TINSPIRE_002: "tinspire002",
  TINSPIRE_003: "tinspire003",
  TINSPIRE_004: "tinspire004",
  TINSPIRE_005: "tinspire005",
  TINSPIRE_006: "tinspire006",
  TINSPIRE_007: "tinspire007",
  TINSPIRE_008: "tinspire008",
  TINSPIRE_009: "tinspire009",
  TINSPIRE_010: "tinspire010",
  TINSPIRE_011: "tinspire011",
  TINSPIRE_012: "tinspire012",
  TINSPIRE_013: "tinspire013",
  TINSPIRE_014: "tinspire014",
  TINSPIRE_015: "tinspire015",
  TINSPIRE_016: "tinspire016",
  AFRICA_000: "africa000",
  AFRICA_001: "africa001",
  AFRICA_002: "africa002",
  AFRICA_003: "africa003",
  AFRICA_004: "africa004",
  AFRICA_005: "africa005",
  AFRICA_006: "africa006",
  AFRICA_007: "africa007",
  AFRICA_008: "africa008",
  AFRICA_009: "africa009",
  AFRICA_010: "africa010",
  AFRICA_011: "africa011",
  AFRICA_012: "africa012",
  AFRICA_013: "africa013",
  AFRICA_014: "africa014",
  AFRICA_015: "africa015",
  AFRICA_016: "africa016",
  SKI_000: "ski000",
  SKI_001: "ski001",
  SKI_002: "ski002",
  SKI_003: "ski003",
  SKI_004: "ski004",
  SKI_005: "ski005",
  SKI_006: "ski006",
  SKI_007: "ski007",
  SKI_008: "ski008",
  SKI_009: "ski009",
  SKI_010: "ski010",
  SKI_011: "ski011",
  SKI_012: "ski012",
  SKI_013: "ski013",
  SKI_014: "ski014",
  SKI_015: "ski015",
  GREENSEA_000: "greensea000",
  GREENSEA_001: "greensea001",
  GREENSEA_002: "greensea002",
  GREENSEA_003: "greensea003",
  GREENSEA_004: "greensea004",
  GREENSEA_005: "greensea005",
  GREENSEA_006: "greensea006",
  GREENSEA_007: "greensea007",
  GREENSEA_008: "greensea008",
  GREENSEA_009: "greensea009",
  GREENSEA_010: "greensea010",
  GREENSEA_011: "greensea011",
  GREENSEA_012: "greensea012",
  GREENSEA_013: "greensea013",
  GREENSEA_014: "greensea014",
  GREENSEA_015: "greensea015",
  SUNFLOWER_000: "sunflower000",
  SUNFLOWER_001: "sunflower001",
  SUNFLOWER_002: "sunflower002",
  SUNFLOWER_003: "sunflower003",
  SUNFLOWER_004: "sunflower004",
  SUNFLOWER_005: "sunflower005",
  SUNFLOWER_006: "sunflower006",
  SUNFLOWER_007: "sunflower007",
  SUNFLOWER_008: "sunflower008",
  SUNFLOWER_009: "sunflower009",
  SUNFLOWER_010: "sunflower010",
  SUNFLOWER_011: "sunflower011",
  SUNFLOWER_012: "sunflower012",
  SUNFLOWER_013: "sunflower013",
  SUNFLOWER_014: "sunflower014",
  SUNFLOWER_015: "sunflower015",
  LUXURY_000: "luxury000",
  LUXURY_001: "luxury001",
  LUXURY_002: "luxury002",
  LUXURY_003: "luxury003",
  LUXURY_004: "luxury004",
  LUXURY_005: "luxury005",
  LUXURY_006: "luxury006",
  LUXURY_007: "luxury007",
  LUXURY_008: "luxury008",
  LUXURY_009: "luxury009",
  LUXURY_010: "luxury010",
  LUXURY_011: "luxury011",
  LUXURY_012: "luxury012",
  LUXURY_013: "luxury013",
  LUXURY_014: "luxury014",
  LUXURY_015: "luxury015",
  /**
   * existing travel domains
   */
  TINSPIRE: "tinspire",
  TINSPIRE2: "tinspire2",
  TINSPIRE3: "tinspire3",
  AFRICA: "africa",
  SKI: "ski",
  GREENSEA: "greensea",
  SUNFLOWER: "sunflower",
  LUXURY: "luxury",
  /**
   * existing white label and other domains
   */
  ACA: "aca",
  BGS: "bgs",
  ONEDOLLARGIFTS: "onedollargifts",
  FIVEDOLLARGIFTCOM: "fivedollargiftcom",
  RCMOTORS: "rcmotors",
  DEV: "dev",
};

const travelDomains = [
  domainBuildCodes.HOME555TRAVEL,
  domainBuildCodes.DEV,
  domainBuildCodes.AFRICA,
  domainBuildCodes.GREENSEA,
  domainBuildCodes.LUXURY,
  domainBuildCodes.SKI,
  domainBuildCodes.SUNFLOWER,
  domainBuildCodes.TINSPIRE,
  domainBuildCodes.TINSPIRE2,
  domainBuildCodes.TINSPIRE3,
  /**
   * new 555travel domains
   */
  domainBuildCodes.TINSPIRE_000,
  domainBuildCodes.TINSPIRE_001,
  domainBuildCodes.TINSPIRE_002,
  domainBuildCodes.TINSPIRE_003,
  domainBuildCodes.TINSPIRE_004,
  domainBuildCodes.TINSPIRE_005,
  domainBuildCodes.TINSPIRE_006,
  domainBuildCodes.TINSPIRE_007,
  domainBuildCodes.TINSPIRE_008,
  domainBuildCodes.TINSPIRE_009,
  domainBuildCodes.TINSPIRE_010,
  domainBuildCodes.TINSPIRE_011,
  domainBuildCodes.TINSPIRE_012,
  domainBuildCodes.TINSPIRE_013,
  domainBuildCodes.TINSPIRE_014,
  domainBuildCodes.TINSPIRE_015,
  domainBuildCodes.TINSPIRE_016,
  domainBuildCodes.AFRICA_000,
  domainBuildCodes.AFRICA_001,
  domainBuildCodes.AFRICA_002,
  domainBuildCodes.AFRICA_003,
  domainBuildCodes.AFRICA_004,
  domainBuildCodes.AFRICA_005,
  domainBuildCodes.AFRICA_006,
  domainBuildCodes.AFRICA_007,
  domainBuildCodes.AFRICA_008,
  domainBuildCodes.AFRICA_009,
  domainBuildCodes.AFRICA_010,
  domainBuildCodes.AFRICA_011,
  domainBuildCodes.AFRICA_012,
  domainBuildCodes.AFRICA_013,
  domainBuildCodes.AFRICA_014,
  domainBuildCodes.AFRICA_015,
  domainBuildCodes.AFRICA_016,
  domainBuildCodes.SKI_010,
  domainBuildCodes.SKI_011,
  domainBuildCodes.SKI_012,
  domainBuildCodes.SKI_013,
  domainBuildCodes.SKI_014,
  domainBuildCodes.SKI_015,
  domainBuildCodes.SKI_000,
  domainBuildCodes.SKI_001,
  domainBuildCodes.SKI_002,
  domainBuildCodes.SKI_003,
  domainBuildCodes.SKI_004,
  domainBuildCodes.SKI_005,
  domainBuildCodes.SKI_006,
  domainBuildCodes.SKI_007,
  domainBuildCodes.SKI_008,
  domainBuildCodes.SKI_009,
  domainBuildCodes.GREENSEA_010,
  domainBuildCodes.GREENSEA_011,
  domainBuildCodes.GREENSEA_012,
  domainBuildCodes.GREENSEA_013,
  domainBuildCodes.GREENSEA_014,
  domainBuildCodes.GREENSEA_015,
  domainBuildCodes.GREENSEA_000,
  domainBuildCodes.GREENSEA_001,
  domainBuildCodes.GREENSEA_002,
  domainBuildCodes.GREENSEA_003,
  domainBuildCodes.GREENSEA_004,
  domainBuildCodes.GREENSEA_005,
  domainBuildCodes.GREENSEA_006,
  domainBuildCodes.GREENSEA_007,
  domainBuildCodes.GREENSEA_008,
  domainBuildCodes.GREENSEA_009,
  domainBuildCodes.SUNFLOWER_000,
  domainBuildCodes.SUNFLOWER_001,
  domainBuildCodes.SUNFLOWER_002,
  domainBuildCodes.SUNFLOWER_003,
  domainBuildCodes.SUNFLOWER_004,
  domainBuildCodes.SUNFLOWER_005,
  domainBuildCodes.SUNFLOWER_006,
  domainBuildCodes.SUNFLOWER_007,
  domainBuildCodes.SUNFLOWER_008,
  domainBuildCodes.SUNFLOWER_009,
  domainBuildCodes.SUNFLOWER_010,
  domainBuildCodes.SUNFLOWER_011,
  domainBuildCodes.SUNFLOWER_012,
  domainBuildCodes.SUNFLOWER_013,
  domainBuildCodes.SUNFLOWER_014,
  domainBuildCodes.SUNFLOWER_015,
  domainBuildCodes.LUXURY_000,
  domainBuildCodes.LUXURY_001,
  domainBuildCodes.LUXURY_002,
  domainBuildCodes.LUXURY_003,
  domainBuildCodes.LUXURY_004,
  domainBuildCodes.LUXURY_005,
  domainBuildCodes.LUXURY_006,
  domainBuildCodes.LUXURY_007,
  domainBuildCodes.LUXURY_008,
  domainBuildCodes.LUXURY_009,
  domainBuildCodes.LUXURY_010,
  domainBuildCodes.LUXURY_011,
  domainBuildCodes.LUXURY_012,
  domainBuildCodes.LUXURY_013,
  domainBuildCodes.LUXURY_014,
  domainBuildCodes.LUXURY_015,
];

const shoppingDomains = [
  domainBuildCodes.DEV,
  domainBuildCodes.BGS,
  domainBuildCodes.FIVEDOLLARGIFTCOM,
  domainBuildCodes.ONEDOLLARGIFTS,
  domainBuildCodes.RCMOTORS,
];

const whiteLabelDomains = [domainBuildCodes.ACA];

/**
 * ***************************************************************
 * ***************************************************************
 * ***************************************************************
 * ***************************************************************
 * ***************************************************************
 * ***************************************************************
 * ***************************************************************
 * ***************************************************************
 * ***************************************************************
 */

export const isTravelDomain = domainBuildCode => {
  const resp = travelDomains.includes(domainBuildCode);
  // console.log(
  //   "FROM: isTravelDomain: ",
  //   "domainBuildCode: ",
  //   domainBuildCode,
  //   " resp: ",
  //   resp
  // );
  return resp;
};

export const isShoppingDomain = domainBuildCode =>
  shoppingDomains.includes(domainBuildCode);

export const isWhiteLabelDomain = domainBuildCode =>
  whiteLabelDomains.includes(domainBuildCode);

export const isHomePage = domainBuildCode => domainBuildCode.includes("home");

export const isFooterExtendedMainItemTitles = domainBuildCode =>
  domainBuildCode === domainBuildCodes.ONEDOLLARGIFTS;

export const emojiFeaturedItemTitle = (domainBuildCode, structure) => {
  if (isWhiteLabelDomain(domainBuildCode)) {
    const rand = Math.floor(Math.random() * 2);
    const emojis = ["✨", "💡"];

    return emojis[rand];
  }

  return structure === "shopping_A" ? "🛒" : "📍";
};

export const generateSub = _txt => {
  const txt = _txt.split("--")[1] ?? _txt;
  const MAX_LENGTH_SUB_TEXT_PARAM = 90;
  const tarr = txt.split(" ");
  let res = "",
    count = 0;

  const commonWordsToRemove = [
    "and",
    "of",
    "the",
    "in",
    "on",
    "at",
    "to",
    "a",
    "an",
  ];
  const punctuationToRemove = [",", ".", ";", ":", "!", "?"];

  for (const word of tarr) {
    const lword = word.length + 1; // + 1 stands for extra space

    if (count + lword <= MAX_LENGTH_SUB_TEXT_PARAM) {
      res += !!res ? " " + word : word;
      count += lword;
    } else {
      break;
    }
  }

  // Remove the last word if it is a common word to remove or contains punctuation
  const resArr = res.split(" ");
  const lastWord = resArr[resArr.length - 1];
  if (
    commonWordsToRemove.includes(lastWord) ||
    punctuationToRemove.some(p => lastWord.includes(p))
  ) {
    resArr.pop();
  }

  // Join the array back into a string and remove any line breaks or more than one space sequence
  return resArr.join(" ").replace(/\s+/g, " ").trim();
};

export const isExtendedHtmlTitle = domainBuildCode =>
  !isWhiteLabelDomain(domainBuildCode) && !isHomePage(domainBuildCode);

/**
 * Handle which affiliate widget to show: "shopping", "travelling", "none"
 */

export const WIDGET_TYPE_SELECTION = {
  SHOPPING: "shopping",
  TRAVEL: "travel",
  NONE: "none",
};

export const affiliateWidgetSelectTop = (domainBuildCode, structure) => {
  if (isWhiteLabelDomain(domainBuildCode)) return WIDGET_TYPE_SELECTION.NONE;
  if (isTravelDomain(domainBuildCode) && structure !== "shopping_A")
    return WIDGET_TYPE_SELECTION.TRAVEL;

  return WIDGET_TYPE_SELECTION.SHOPPING;
};

export const affiliateWidgetSelectBottom = (domainBuildCode, structure) => {
  if (isWhiteLabelDomain(domainBuildCode)) return WIDGET_TYPE_SELECTION.NONE;
  if (structure === "shopping_A") return WIDGET_TYPE_SELECTION.SHOPPING;
  return WIDGET_TYPE_SELECTION.NONE;
};

export const showAlt = structure => {
  return !structure || structure !== "travel_Q";
};
export const generateBookingWidgetText = (
  config,
  frontmatter,
  i18n_prefix,
  i18n_main = "en"
) => {
  return frontmatter.structure !== "travel_A"
    ? config[`visit_general_${i18n_prefix || i18n_main}`]
    : config[`visit_main_item_${i18n_prefix || i18n_main}`].replace(
        /\[MAIN_ITEM\]/g,
        frontmatter[`main_item_translated_${i18n_prefix || i18n_main}`]
      );
};

export const generateGoToBookingMapWidgetLinkText = (
  config,
  frontmatter,
  i18n_prefix,
  i18n_main = "en"
) => {
  const mainItem =
    frontmatter[`main_item_translated_${i18n_prefix || i18n_main}`];

  // console.dir({
  //   FROM: "🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍",
  //   mainItem,
  //   i18n_prefix,
  //   i18n_main,
  //   config,
  // });

  if (mainItem) {
    const text = config[
      `find_hotels_move_to_booking_widget_${i18n_prefix || i18n_main}`
    ].replace(/\[MAIN_ITEM\]/g, mainItem);

    // console.dir({
    //   FROM: "🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍",
    //   text: text,
    // });

    return text;
  }
  return "";
};

export const generateAmazonWidgetTextHTML = (
  config,
  frontmatter,
  amazonLink,
  i18n_prefix,
  i18n_main = "en"
) => {
  return frontmatter.structure !== "shopping_A" &&
    !isShoppingDomain(process.env.GATSBY_NODE_BUILD_CODE_BY_DOMAIN)
    ? config[`buy_general_${i18n_prefix || i18n_main}`].replace(
        /\[AMAZON_LINK\]/g,
        amazonLink
      )
    : config[`buy_main_item_${i18n_prefix || i18n_main}`]
        .replace(
          /\[MAIN_ITEM\]/g,
          frontmatter[`main_item_translated_${i18n_prefix || i18n_main}`]
        )
        .replace(/\[AMAZON_LINK\]/g, amazonLink);
};

export const generateOptimalRouteTitle = (
  config,
  frontmatter,
  i18n_prefix,
  i18n_main = "en"
) => {
  frontmatter.structure !== "shopping_A"
    ? config[`optimal_route_${i18n_prefix || i18n_main}`].replace(
        /\[MAIN_ITEM\]/g,
        frontmatter[`main_item_translated_${i18n_prefix || i18n_main}`]
      )
    : config[`optimal_route_shopping_${i18n_prefix || i18n_main}`].replace(
        /\[MAIN_ITEM\]/g,
        frontmatter[`main_item_translated_${i18n_prefix || i18n_main}`]
      );
};

export const stripHtmlTags = html => {
  // console.dir({
  //   FROM: "📚📚📚📚📚📚📚📚📚📚📚📚📚📚📚📚📚📚📚📚📚📚 stripHtmlTags",
  //   ["supposed to be an html"]: html,
  // });
  // Match text content between `>` and `<` ignoring HTML tags
  return html
    .replace(/>\s*</g, "><") // Remove unnecessary whitespace between tags
    .replace(/<[^>]+>/g, "") // Remove all tags
    .trim()
    .replace(/&#(\d+);/g, (match, dec) => {
      return String.fromCharCode(dec);
    });
};

export const generateBlogPostSchema = ({
  title,
  description,
  images = [],
  url,
  datePublished = new Date().toISOString(),
  dateModified = new Date().toISOString(),
  articleBody,
  keywords = "",
  lang = "en",
  type = "BlogPosting",
}) => {
  if (!title || !url || !datePublished) {
    console.warn(
      `%c⚠️ Missing required fields for schema generation!`,
      "color: yellow; font-weight: bold; font-size: 16px;"
    );
    console.warn(
      `%cRequired fields: title, url, datePublished`,
      "color: orange; font-weight: bold;"
    );
    console.warn(
      `%cProvided values:\n- title: ${title || "❌ Missing"}\n- url: ${
        url || "❌ Missing"
      }\n- datePublished: ${datePublished || "❌ Missing"}`,
      "color: red; font-style: italic;"
    );
    throw new Error(
      "SCHEMA.ORG ERROR: Title, URL, and datePublished are required fields."
    );
  }

  const res = {
    "@context": "https://schema.org",
    "@type": type,
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": url,
    },
    headline: type === "BlogPosting" ? stripHtmlTags(title) : title,
    description: description,
    image: images.map(src => ({ "@type": "ImageObject", url: src })),
    datePublished: datePublished,
    dateModified: dateModified || datePublished,
    articleBody:
      type === "BlogPosting" ? stripHtmlTags(articleBody) : articleBody, //stripHtmlTags(articleBody), // Convert HTML to plain text
    keywords: keywords,
    inLanguage: lang,
  };

  // console.log(
  //   "🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍🔍�"
  // );
  // console.dir({
  //   FROM: "return schema",
  //   res,
  // });

  return res;
};
